import React, { Suspense, lazy } from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
// Lazy load below-fold sections - reduces initial JS bundle significantly
const FrecuenciaSection = lazy(() => import('../components/FrecuenciaSection').then(m => ({
  default: m.FrecuenciaSection
})));
const CienciaSection = lazy(() => import('../components/CienciaSection').then(m => ({
  default: m.CienciaSection
})));
const TestimoniosSection = lazy(() => import('../components/TestimoniosSection').then(m => ({
  default: m.TestimoniosSection
})));
const IdentitySection = lazy(() => import('../components/IdentitySection').then(m => ({
  default: m.IdentitySection
})));
const ProtocoloSection = lazy(() => import('../components/ProtocoloSection').then(m => ({
  default: m.ProtocoloSection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SalesNotification = lazy(() => import('../components/SalesNotification').then(m => ({
  default: m.SalesNotification
})));
export function LandingPage() {
  return <div className="min-h-screen bg-dark font-sans text-white selection:bg-gold/30 selection:text-gold overflow-x-hidden w-full" data-id="element-386">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[99999] focus:bg-gold focus:text-dark focus:px-4 focus:py-2 focus:rounded focus:font-bold" data-id="element-387">
        Saltar al contenido principal
      </a>
      <Navbar data-id="element-388" />
      <main id="main-content" className="overflow-x-hidden" data-id="element-389">
        <HeroSection data-id="element-390" />
        <Suspense fallback={<div className="min-h-[50vh] bg-dark" data-id="element-392" />} data-id="element-391">
          <FrecuenciaSection data-id="element-393" />
          <CienciaSection data-id="element-394" />
          <TestimoniosSection data-id="element-395" />
          <ProtocoloSection data-id="element-396" />
          <IdentitySection data-id="element-397" />
        </Suspense>
      </main>
      <Suspense fallback={null} data-id="element-398">
        <Footer data-id="element-399" />
        <SalesNotification data-id="element-400" />
      </Suspense>
    </div>;
}